module.exports = __webpack_public_path__ + "static/assets/0ec577a4fbaedfe87a45dc0bed413b34.svg";